import { useBooleanState } from '@cian/react-utils';
import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { AD_BANNER_MF_MANIFEST_SETTING_KEY } from 'shared/constants/microfrontends';
import { useApplicationContext } from 'shared/utils/applicationContext';

import { SpecialProjectBannerSkeleton } from '../../components/SpecialProjectBannerSkeleton';
import { selectIsCommercial } from '../../selectors/selectIsCommercial';
import { AdfoxContextProviderProps } from '../../utils/AdfoxContext';
import { AdBannerMicrofrontendSpecialProjectContainer } from '../AdBannerMicrofrontendSpecialProjectContainer';
import { AdFoxBannerContainer } from '../AdFoxBannerContainer';

const POST_VIEW_ANALYTICS_DATA: AdfoxContextProviderProps['postViewAnalyticsData'] = {
  isSp: true,
  place: 'above_offers',
};

const SIZE: AdfoxContextProviderProps['size'] = { width: '100%', height: 174 };
const P_PARAMS: AdfoxContextProviderProps['pParams'] = { p1: 'cwlpf', p2: 'hyhj' };
const P_PARAMS_COMMERCIAL: AdfoxContextProviderProps['pParams'] = { p1: 'dmepr', p2: 'hyhj' };

export function SpecialProjectBannerContainer() {
  const { config } = useApplicationContext();
  const manifest = config.get<IMicrofrontendManifest>(AD_BANNER_MF_MANIFEST_SETTING_KEY);
  const { state: isVisibleBanner, setFalse: setBannerInvisible } = useBooleanState(true);
  const isCommercial = useSelector(selectIsCommercial);

  if (!isVisibleBanner) {
    return null;
  }

  return (
    <SpecialProjectBannerSkeleton>
      {manifest ? (
        <AdBannerMicrofrontendSpecialProjectContainer
          manifest={manifest}
          isCommercial={isCommercial}
          onStub={setBannerInvisible}
          onError={setBannerInvisible}
          onClose={setBannerInvisible}
        />
      ) : (
        <AdFoxBannerContainer
          onStub={setBannerInvisible}
          onError={setBannerInvisible}
          bannerName="Баннер AdFox для спецпроектов"
          size={SIZE}
          pParams={isCommercial ? P_PARAMS_COMMERCIAL : P_PARAMS}
          postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
        />
      )}
    </SpecialProjectBannerSkeleton>
  );
}
